import './modules/modernizr-custom';
import Accordions from './modules/accordion';
import Modals from './modules/modal';
// import Tabs from './modules/tabs';
// import Includes from './modules/include';
// import AnchorLink from './modules/anchorlink';
// import HashUrl from './modules/hash_url';
import AgreeCheck from './modules/check';
// import './modules/carousel';
import Zaiko from './modules/zaiko';
import './modules/zaiko_cart';
import './modules/gift';
// import ColorCart from './modules/colorcart';
// import SetCart from './modules/setcart';
// import Review from './modules/review';
// import './modules/scroll-effect';
// import './modules/timer';
// import './modules/intersection-observer';

// YouCamメイクシミュレーター
// import YouCam from './modules/youcam';

// // API読み込み
// (function (d,k) {
//   var s = d.createElement('script');
//   s.type = 'text/javascript';
//   s.async = true;
//   s.src = 'https://plugins-media.makeupar.com/c317/sdk.js?apiKey=' + k;
//   var x = d.getElementsByTagName('script')[0];
//   x.parentNode.insertBefore(s, x);
// })(document, 'y6xyy2zXnvV8pqT4m49JQ==')
// // ツール初期化
// window.ymkAsyncInit = function() {
//   YMK.init({'autoOpen': true,'language': 'jpn'});
//   window.YMK.addEventListener('loaded', function() {
//     const vmModal = document.getElementById('modal-vm');
//     if(vmModal){
//       const envBox = vmModal.querySelector('.mod-vmmodal--vmcont_env');
//       const vmBtnBox = vmModal.querySelector('.mod-vmmodal--vmcont_function');
//       envBox.style.display = 'none';
//       vmBtnBox.style.display = 'block';
//     }
//   });
// }
// //YouCamメイクシミュレーター

document.addEventListener('DOMContentLoaded',function(){

  //html include
  // const includeContainers = Array.from(document.querySelectorAll('[data-inc]'));
  // includeContainers.forEach((container) => {
  //   new Includes(container);
  // });

  //在庫制御
  const carts = document.querySelectorAll('.js-zaiko');
  const zaikoFlag = 'zaiko-completed';
  const zaikocb = function (entries, observer) {
    entries.forEach(entry => {
      if (entry.isIntersecting) {
        if(!entry.target.classList.contains(zaikoFlag)){
          new Zaiko(entry.target);
          entry.target.classList.add(zaikoFlag);
        }
        observer.unobserve(entry.target);
      }
    });
  };
  const zaikoIOoptions = {
      root: null,
      rootMargin: "100px",
      threshold: 0
  };
  const zaikoio = new IntersectionObserver(zaikocb, zaikoIOoptions);
  if(carts){
    carts.forEach((cart,index) => {
      cart.setAttribute('data-zaiko_serial', index + 1);
      zaikoio.observe(cart);
    });
  }


  // レビューAPI
  // const reviewCont = Array.from(document.querySelectorAll('.js-review'));
  // reviewCont.forEach((cont) => {
  //   new Review(cont);
  // });

  // Accordion
  const accordionArray = Array.from(document.querySelectorAll('.js-acc'));
  accordionArray.forEach((accordion,index) => {
    accordion.setAttribute('data-accordion_serial', 'accordion_' + (index + 1));
    new Accordions(accordion);
  });

  //YouCamメイクシミュレーター
  // const vmModalBtns = Array.from(document.querySelectorAll('.js-vmmodal-open'));
  // vmModalBtns.forEach( (modalBtn, index) => {
  //   modalBtn.setAttribute('onclick', '_sc.gene_click(\'simulator_' + (index + 1) + '\',\'\');');
  //   new YouCam(modalBtn);
  // });

  //タブ切り替え
  // const tabsBtn = Array.from(document.querySelectorAll('.js-tabs-btn'));
  // tabsBtn.forEach((tabBtn) => {
  //   new Tabs(tabBtn);
  // });

  // 同意チェック
  const checkboxs = Array.from(document.querySelectorAll('.js-agreecheck-input'));
  checkboxs.forEach((check) => {
    new AgreeCheck(check);
  })

  window.addEventListener('load',function(){

    //Modal window
    const modalArray = Array.from(document.querySelectorAll('.mod-modal'));
    modalArray.forEach( (modal) => {
      new Modals(modal);
    });
    const modalOpenButtonArray = Array.from(document.querySelectorAll('.js-modal-open'));
    modalOpenButtonArray.forEach((button,index) => {
      button.setAttribute('onclick', "_sc.gene_click('modal_" + (index + 1) + "','');");
    });

    // 色玉在庫制御
    // const colorCarts = Array.from(document.querySelectorAll('.js-colorcart-irodama'));
    // colorCarts.forEach((irodamabtn,index) => {
    //   irodamabtn.setAttribute('data-colorcart_serial', index + 1);
    //   new ColorCart(irodamabtn);
    // });

    // 複数商品選択カート
    // const setCarts = Array.from(document.querySelectorAll('.js-setcart'));
    // setCarts.forEach((setCart,index) => {
    //   setCart.setAttribute('data-setcart_serial', index + 1);
    //   new SetCart(setCart);
    // });

    //smooth anchor
    // 上部固定要素があれば指定する
    // const fixedContent = document.querySelector('.mod-fixednav.m-upper');
    //ページ内リンク
    // let anchorLinks = Array.from(document.querySelectorAll('a'));
    // anchorLinks.forEach((link) => {
    //   // new AnchorLink(link,fixedContent);
    //   // fixedContentなしVersion
    //   new AnchorLink(link);
    // });
    // //ハッシュ付きURLでアクセス
    // // new HashUrl(fixedContent);
    // // fixedContentなしVersion
    // new HashUrl();

    const $actionWrap = document.querySelector('.action_wrap')
    const $campTxt = document.querySelector('.camp_txt')

    window.onscroll = function(){
      if($actionWrap.getBoundingClientRect().bottom + document.body.scrollTop < window.innerHeight){
        $actionWrap.classList.add('active');
        setTimeout(function() {
          $campTxt.classList.add('show');
        }, 1000);
      }else{
        // $actionWrap.classList.remove('active');
        // $campTxt.classList.remove('show');
      }
    }


    const shape = document.querySelector(".continue_main_line");

    let angle = 0;
    let ease = 0;
    function drawCircle() {
      if( angle < 90 ) {
        ease =  0.4;
      }else if( angle < 200 ) {
        ease = 0.3;
      }else if( angle < 350 ) {
        ease = 0.1;
      }
      
      if( angle < 327 ) {
        angle += ease;
        shape.style.backgroundImage = `conic-gradient(#bfaa7e ${angle}deg, transparent ${angle}deg)`;
        requestAnimationFrame(drawCircle);
        // console.log(ease);
      }
    }

    let scroll;
    const winH = $(window).height()/2;
    const objTop = $('.continue_main_line').offset().top;
    $(window).on('scroll', function(){
      scroll = $(window).scrollTop();
      if(scroll >= objTop - winH){
        requestAnimationFrame(drawCircle);
      }
    });





    function onClick(){
      var clickObj = $(".scClick");
      clickObj.each (function(){
        var clickid = $(this).attr("data-clickid");
        var clickLink = $(this).attr("href");
        $(this).attr("onclick","_sc.gene_click('" + clickid + "','" + clickLink +"');");
      })
    }
    onClick();







    

  });

});
